<template>
    <div class="infoCard">
        <b-card header="header" v-if="data.account_info.notes"> 
            <template v-slot:header  >
                <h6> {{$t('signal.generalInfo.accountNotes')}} </h6>
            </template>
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.generalInfo.type')}} </b-th>
                    <b-th> {{$t('signal.generalInfo.desc')}} </b-th>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="note in data.account_info.notes" :key="note.id"> 
                        <b-td> {{note.title}} </b-td>
                        <b-td > <span v-html="note.desc"></span></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
    
        <b-card> 
              <ul class="info">
                <li>
                    <strong>{{$t('signal.generalInfo.accountPartNo')}} </strong> 
                    <span> {{data.account_info.account_info.account.account_no}} - {{data.account_info.PartNo}} </span>
                </li>
                    <li>
                    <strong> {{$t('signal.generalInfo.accountName')}}: </strong> 
                    <span> {{data.account_info.name}} </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.accountType')}} </strong> 
                    <span> {{data.account_info.account_type.name}} </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.accountJob')}} </strong> 
                    <span> {{data.account_info.job.name}} </span>
                </li>
                <li v-if="data.account_info.account_info.customer.customer_company">
                    <strong> {{$t('signal.generalInfo.technicalService')}} </strong> 
                    <span v-for="(company, i) in data.account_info.account_info.customer.customer_company " :key="company.company_info.id">
                        {{company.company_info.name}}
                        {{i !== data.account_info.account_info.customer.customer_company.length - 1 ? '->' : ''}}
                    </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.panelBrand')}} </strong> 
                    <span> {{data.account_info.account_info.account.panel_brand.name}} </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.panelModel')}} </strong> 
                    <span> {{data.account_info.account_info.account.panel_model.name}} </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.comProtocol')}} </strong> 
                    <span>  {{data.account_info.account_info.account.signal_protocol.name}} </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.connectionDate')}} </strong> 
                    <span> {{dateFormat(data.account_info.account_info.account.connectiond_date)}}  </span>
                </li>
                <li>
                    <strong> {{$t('signal.generalInfo.comType')}} </strong> 
                    <span> 
                        <b-badge :variant="comControl.com_type == 0 ? 'primary' :  comControl.com_type == 1 ? 'danger' : 'success'" v-for="comControl in data.account_info.account_com_control" :key="comControl.id"> 
                            {{comControl.com_type == 0 ? 'GPRS' :  comControl.com_type == 1 ? 'Telefon Hattı' : 'Data Hattı'}}
                        </b-badge>
                    </span>
                </li>
            </ul>
        </b-card>
    </div>
    
</template>

<script>
    import moment from 'moment'

    export default {
        name: "GeneralInfo",
        props:{
            data: Object
        },
        methods:{
            dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY HH:mm') 
            },
        }
    }
</script>

<style scoped>
    @import "../styles/generalInfo.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/components/GeneralInfo.vue